import { Box, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { COMMON_STYLE } from '../../../../Utility/Constants'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation'

const intraPressureState = {
  patient_details: {},
  clinic_id: '',
  appointment_id: '',
  patient_id: '',
  intraPresData: [],
  intraPresComments: '',
  dupIntraPresComments: '',
  dupIntraPresData: '[]'
}

const UmaIntracularPressure = React.forwardRef((props, ref) => {
  const [intra, setIntra] = useState(intraPressureState)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - INTRAOCULAR PRESSURE`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - INTRAOCULAR PRESSURE`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performIntracularPressureAction: () => {
      if ((JSON.stringify(intra.intraPresData) !== intra.dupIntraPresData) || JSON.stringify(intra.intraPresComments) !== intra.dupIntraPresComments) {
        postIntraOcularPressureData()
      }
    }
  }))

  const apicalls = async () => {
    await getIntraOcularPressureData()
  }

  const getIntraOcularPressureData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_INTRAOCULAR_PRESSURE +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let intraArray = [
          { "eye_type": "RE", "NCT": '', "APPLANATION_TONOMETRY": '', "CCT": '', "CORRECTION_FACTOR": '', "CIOP": '', 'comment': '' },
          { "eye_type": "LE", "NCT": '', "APPLANATION_TONOMETRY": '', "CCT": '', "CORRECTION_FACTOR": '', "CIOP": '', 'comment': '' }
        ]
        let intraList = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setIntra((prev) => ({
          ...prev,
          intraPresData: Object.keys(intraList)?.length > 0 ? intraList?.intraocular : intraArray,
          intraPresComments: Object.keys(intraList)?.length > 0 ? intraList?.comment : '',
          dupIntraPresData: Object.keys(intraList)?.length > 0 ? JSON.stringify(intraList?.intraocular) : JSON.stringify(intraArray),
          dupIntraPresComments: Object.keys(intraList)?.length > 0 ? JSON.stringify(intraList?.comment) : JSON.stringify('')
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const postIntraOcularPressureData = async () => {
    try {
      let ListData = intra?.intraPresData?.map((item) => {
        return {
          ...item,
          eye_type: item?.eye_type,
          NCT: item?.NCT || '',
          APPLANATION_TONOMETRY: item?.APPLANATION_TONOMETRY || '',
          CCT: item?.CCT || '',
          CIOP: item?.CIOP || '',
          CORRECTION_FACTOR: item?.CORRECTION_FACTOR || '',
          comment: item?.comment || ''
        }
      })

      let data = {
        appointment_id: props?.props?.appointment_id,
        comment: intra?.intraPresComments,
        intraocular: ListData
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_INTRAOCULAR_PRESSURE  + '?doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getIntraOcularPressureData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const textBox = (names, values, width, index, placeholders, disable) => {
    try {
      return (
        <TextField
          size='small'
          sx={{ width: width }}
          disabled={props?.props?.patient_transfered || props?.props?.isLocked || disable}
          maxRows={intra.intraPresData[index]['comment'] ? 5 : 1}
          value={values}
          onChange={(e) => {
            let { value } = e.target
            if(names === 'comment'){
              if(value?.length <= 250){
                let intraData = [...intra.intraPresData]
                intraData[index] = { ...intraData[index], [names]: value }
                setIntra((prev) => ({ ...prev, intraPresData: intraData }))
              }
            }else{
              if (CommonValidation.DecimalNumber(value)) {
                let intraData = [...intra.intraPresData]
                intraData[index] = { ...intraData[index], [names]: value }
                if (names === 'CCT') {
                  let selectedApplanation = intraData[index]['APPLANATION_TONOMETRY'] || 0;
                  if (+value === 0 || +selectedApplanation === 0) {
                    intraData[index]['CIOP'] = ''
                  } else if (+value === 545) {
                    intraData[index]["CCT"] = value
                    intraData[index]["CIOP"] = 0
                    intraData[index]["CORRECTION_FACTOR"] = 545
                  } else if (+value > 0) {
                    let getCorrection = (((+value) - 545) / 50 * 2.5);
                    let getCIOP = parseInt(selectedApplanation - getCorrection)
                    intraData[index]["CCT"] = value
                    intraData[index]["CIOP"] = getCIOP
                    intraData[index]["CORRECTION_FACTOR"] = getCorrection
                  }
                }
                setIntra((prev) => ({ ...prev, intraPresData: intraData }))
              }
            }
          }}
          placeholder={placeholders}
          InputProps={{
            style: intra.intraPresData[index]['comment'] ? { maxHeight: COMMON_STYLE.MAX_HEIGHT } : { height: COMMON_STYLE.HEIGHT },
            emed_tid: 'intra_ocular'
          }}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card'>
            <Typography className='doc_notes_header_card_font'>Intraocular Pressure</Typography>
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'}>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                    <TableCell className='doc_notes_tbl_header'>NCT</TableCell>
                    <TableCell className='doc_notes_tbl_header'>AT</TableCell>
                    <TableCell className='doc_notes_tbl_header'>CCT</TableCell>
                    <TableCell className='doc_notes_tbl_header'>CIOP</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Comments</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {intra?.intraPresData?.length > 0 ? intra?.intraPresData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('NCT', item?.NCT, '5dvw', index, 'NCT')}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('APPLANATION_TONOMETRY', item?.APPLANATION_TONOMETRY, '5dvw', index, 'AT')}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('CCT', item?.CCT, '5dvw', index, 'CCT')}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('CIOP', item?.CIOP, '5dvw', index, 'CIOP', true)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('comment', item?.comment, '10dvw', index, 'Comment')}
                        </TableCell>
                      </TableRow>
                    )
                  }) : <TableRow><TableCell align='center' colSpan={6}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                </TableBody>
              </Table>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                multiline
                fullWidth
                maxRows={5}
                value={intra.intraPresComments}
                onChange={(e) => {
                  let value = e.target.value
                  if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP) {
                    setIntra((prev) => ({ ...prev, intraPresComments: value }))
                  }
                }}
                placeholder='Comments'
                InputProps={{ emed_tid: 'intra_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
              />
            </Box>
          </Box>
        </Box>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaIntracularPressure